import * as React from 'react';

import type {SalesAutomationClosedLeadAutomation as SalesAutomationClosedLeadAutomationFragment} from 'nutshell-graphql-types';

import {CollapsibleSection} from '../collapsible-section';

import {ClosedLeadFollowupRuleContainer} from './closed-lead-followup-rule-container';

type Props = {
    isLoading: boolean;
    errorMessage: string | null | undefined;
    closedLeadAutomations: SalesAutomationClosedLeadAutomationFragment[];
};

export function ClosedLeadFollowupRules(props: Props) {
    return (
        <CollapsibleSection type='closedLeadFollowupRule'>
            {props.closedLeadAutomations.length > 0 &&
                props.closedLeadAutomations.map((automation) => (
                    <ClosedLeadFollowupRuleContainer
                        key={automation.outcomeType}
                        outcomeType={automation.outcomeType}
                        isLoading={props.isLoading}
                        errorMessage={props.errorMessage}
                        followupLeadAutomations={automation.followupLeadAutomations}
                    />
                ))}
        </CollapsibleSection>
    );
}
